import Button, { ButtonProps } from './Button';
import ButtonType from './type';

export {
  ButtonType,
};

export type { ButtonProps };

export default Button;
